import { put, take } from 'redux-saga/effects';
import guid from 'uuid';

import { ModalType } from 'const';
import { showModal } from 'containers/ModalManager/actions';
import * as ModalManagerModels from 'containers/ModalManager/models';
import { ConfirmationWindowOptions } from 'models';
import { takeModalWindowResponse } from 'utils/takeModalWindowResponse';

export function* showConfirmation(options: ConfirmationWindowOptions, stylesProp?: string): Generator<unknown, boolean> {
  const modalWindowId = guid();

  yield put(showModal(ModalType.CONFIRMATION, options, modalWindowId, stylesProp));
  const { payload: { response } }: ModalManagerModels.Action.IHideModal<boolean> = yield take(takeModalWindowResponse(modalWindowId));

  return response;
}
